// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";

function kindToText(kind) {
  switch (kind) {
    case "Currency" :
      return I18n.t("EURO");
    case "Percent" :
      return I18n.t("%");
    case "Free" :
      return I18n.t("Free");
  }
}

function discountWarningToText(warning) {
  return I18n.t("Cannot be greater than {{max}}");
}

function productExpectedQuantityWarningToText(warning) {
  return I18n.t("Quantity by {{packaging}}");
}

export {
  kindToText,
  discountWarningToText,
  productExpectedQuantityWarningToText,
}
/* I18n Not a pure module */
